// extracted by mini-css-extract-plugin
export default {"phone_number_input_wrapper":"styles_phone_number_input_wrapper__bRK2T","phoneCode":"styles_phoneCode__lNB7k","phoneNumber":"styles_phoneNumber__vJraU"};